import organisationUnits from "./organisation-schedules";

export const ORGANISATION_SCHEDULES_NAMESPACE = `organisations/organisationSchedules`;

export default organisationUnits;
